module.exports = __webpack_public_path__ + "img/07.03817960.jpg";